import { BadgeVariantEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/badge';

export type BookingStatus =
  | 'PendingProcess'
  | 'PendingRefund'
  | 'PendingFlight'
  | 'PendingPayment'
  | 'Flown'
  | 'Cancelled'
  | 'Refused'
  | 'OnHold'
  | 'Available'
  | 'Empty'
  | 'Used';

export const BookingStatusBadge: Record<BookingStatus, BadgeVariantEnum> = {
  PendingProcess: BadgeVariantEnum.WARNING,
  PendingRefund: BadgeVariantEnum.SUCCESS,
  PendingFlight: BadgeVariantEnum.INFO,
  PendingPayment: BadgeVariantEnum.DANGER,
  Flown: BadgeVariantEnum.SUCCESS,
  Cancelled: BadgeVariantEnum.NEW,
  Refused: BadgeVariantEnum.NEW,
  OnHold: BadgeVariantEnum.DANGER,
  Available: BadgeVariantEnum.INFO,
  Empty: BadgeVariantEnum.NEW,
  Used: BadgeVariantEnum.DISABLED
};

export const BookingStatusLabel: Record<BookingStatus, string> = {
  PendingProcess: 'booking_list_component.status_badges.pending_process',
  PendingRefund: 'booking_list_component.status_badges.pending_refund',
  PendingFlight: 'booking_list_component.status_badges.pending_flight',
  PendingPayment: 'booking_list_component.status_badges.pending_payment',
  Flown: 'booking_list_component.status_badges.flown',
  Cancelled: 'booking_list_component.status_badges.cancelled',
  Refused: 'booking_list_component.status_badges.refused',
  OnHold: '',
  Available: 'booking_list_component.status_badges.available',
  Empty: '',
  Used: 'booking_list_component.status_badges.used'
};
